<script setup lang="ts">
  const { t } = useI18n()
  const localePath = useLocalePath()

  useHead({ title: () => t('contact.title') })
</script>

<template>
  <section
    class="page-banner"
    style="
      background-image: url('https://www.sanyau.edu.cn/_upload/article/images/55/b8/2bc88fe64e7ba1577479cf3310d0/c5bd2115-8426-40ba-908a-1f7a63fb8b25.jpg');
    "
  >
    <h2>{{ t('contact.banner') }}</h2>
    <div class="breadcrumb">
      <NuxtLink :to="localePath('/')">{{ t('common.home') }}</NuxtLink>
      &gt; {{ t('contact.breadcrumb') }}
    </div>
  </section>

  <section class="content-section">
    <div class="container">
      <div class="full-content">
        <div class="contact-grid" style="margin-bottom: 40px">
          <div class="contact-card">
            <h3>{{ t('contact.cards.addressTitle') }}</h3>
            <p v-html="t('contact.cards.address')"></p>
          </div>
          <div class="contact-card">
            <h3>{{ t('contact.cards.phoneTitle') }}</h3>
            <p v-html="t('contact.cards.phone')"></p>
          </div>
          <div class="contact-card">
            <h3>{{ t('contact.cards.emailTitle') }}</h3>
            <p v-html="t('contact.cards.email')"></p>
          </div>
        </div>

        <div class="content-card">
          <h3>{{ t('contact.departments.title') }}</h3>
          <div class="table-scroll">
            <table class="data-table">
              <thead>
                <tr>
                  <th>{{ t('contact.departments.colDept') }}</th>
                  <th>{{ t('contact.departments.colPhone') }}</th>
                  <th>{{ t('contact.departments.colEmail') }}</th>
                  <th>{{ t('contact.departments.colOffice') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ t('contact.departments.office') }}</td>
                  <td>{{ t('contact.departments.officePhone') }}</td>
                  <td>{{ t('contact.departments.officeEmail') }}</td>
                  <td>{{ t('contact.departments.officeLocation') }}</td>
                </tr>
                <tr>
                  <td>{{ t('contact.departments.admissions') }}</td>
                  <td colspan="3" style="color: var(--text-secondary)">
                    {{ t('contact.departments.admissionsPending') }}
                    <a
                      href="http://zhaosheng.sanyau.edu.cn/"
                      target="_blank"
                      rel="noopener"
                      style="color: var(--theme-blue)"
                    >
                      zhaosheng.sanyau.edu.cn
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>{{ t('contact.departments.academic') }}</td>
                  <td colspan="3" style="color: var(--text-secondary)">
                    {{ t('contact.departments.pending') }}
                  </td>
                </tr>
                <tr>
                  <td>{{ t('contact.departments.student') }}</td>
                  <td colspan="3" style="color: var(--text-secondary)">
                    {{ t('contact.departments.pending') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="notice" style="margin-top: 20px">
            <span>{{ t('contact.departments.notice') }}</span>
          </div>
        </div>

        <div class="content-card">
          <h3>{{ t('contact.transport.title') }}</h3>
          <p>{{ t('contact.transport.intro') }}</p>

          <div class="highlight-box">
            <h4>{{ t('contact.transport.airTitle') }}</h4>
            <p>{{ t('contact.transport.air') }}</p>
          </div>
          <div class="highlight-box">
            <h4>{{ t('contact.transport.railTitle') }}</h4>
            <p>{{ t('contact.transport.rail') }}</p>
          </div>
          <div class="highlight-box">
            <h4>{{ t('contact.transport.busTitle') }}</h4>
            <p>{{ t('contact.transport.bus') }}</p>
          </div>
          <div class="highlight-box">
            <h4>{{ t('contact.transport.driveTitle') }}</h4>
            <p>{{ t('contact.transport.drive') }}</p>
          </div>
        </div>

        <div
          class="map-placeholder"
          style="
            background-image: url('https://www.sanyau.edu.cn/_upload/article/images/f4/cb/2bd41a6e4f7782b507af0c4047ef/0381d126-fbc0-430e-9a2e-faf88080b1ff.jpg');
          "
        >
          <div
            style="text-align: center; background: rgba(255, 255, 255, 0.92); padding: 30px 40px; border-radius: 12px"
          >
            <p>{{ t('contact.map.title') }}</p>
            <p style="font-size: 13px; color: var(--text-light)">{{ t('contact.map.address') }}</p>
            <a
              href="https://www.sanyau.edu.cn/2024/0522/c576a69534/page.htm"
              target="_blank"
              rel="noopener"
              class="cta-btn"
              style="margin-top: 15px; display: inline-block"
            >
              {{ t('contact.map.cta') }}
            </a>
          </div>
        </div>

        <div class="content-card" style="margin-top: 40px">
          <h3>{{ t('contact.links.title') }}</h3>
          <div style="display: flex; flex-wrap: wrap; gap: 16px; margin-top: 15px">
            <a
              href="https://www.sanyau.edu.cn/"
              target="_blank"
              rel="noopener"
              class="cta-btn"
              style="font-size: 13px; padding: 8px 20px"
            >
              {{ t('contact.links.sanyau') }}
            </a>
            <a
              href="https://www.xinwei-ai.com/"
              target="_blank"
              rel="noopener"
              class="cta-btn cta-btn-gold"
              style="font-size: 13px; padding: 8px 20px"
            >
              {{ t('contact.links.xinwei') }}
            </a>
            <a
              href="http://www.geely.com/"
              target="_blank"
              rel="noopener"
              class="cta-btn"
              style="font-size: 13px; padding: 8px 20px"
            >
              {{ t('contact.links.geely') }}
            </a>
            <a
              href="http://zhaosheng.sanyau.edu.cn/"
              target="_blank"
              rel="noopener"
              class="cta-btn cta-btn-gold"
              style="font-size: 13px; padding: 8px 20px"
            >
              {{ t('contact.links.admissions') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
